import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 60 60\" id=\"icon-play\"><title>play</title><path d=\"M30,60A30,30,0,1,1,60,30,30,30,0,0,1,30,60Zm0-4.44A25.56,25.56,0,1,0,4.44,30,25.57,25.57,0,0,0,30,55.56Z\" fill=\"#fff\" fill-opacity=\"0.4\" /><path d=\"M30,55.56A25.56,25.56,0,1,0,4.44,30,25.57,25.57,0,0,0,30,55.56Z\" fill=\"#091a34\" fill-opacity=\"0.4\" /><path d=\"M21.56,14.2,44,29.88,21.56,45.73Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/play.svg
// module id = 300
// module chunks = 0 1